@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import org.moxultimate.topwithmox.components.layouts.MarkdownLayout as _org_moxultimate_topwithmox_components_layouts_MarkdownLayout
import org.moxultimate.topwithmox.components.layouts.PageLayout as _org_moxultimate_topwithmox_components_layouts_PageLayout
import org.moxultimate.topwithmox.pages.AboutRoute as _org_moxultimate_topwithmox_pages_AboutRoute
import org.moxultimate.topwithmox.pages.AppsAddRoute as _org_moxultimate_topwithmox_pages_AppsAddRoute
import org.moxultimate.topwithmox.pages.AppsCRUDRoute as _org_moxultimate_topwithmox_pages_AppsCRUDRoute
import org.moxultimate.topwithmox.pages.AppsRoute as _org_moxultimate_topwithmox_pages_AppsRoute
import org.moxultimate.topwithmox.pages.AppsUpdateRoute as _org_moxultimate_topwithmox_pages_AppsUpdateRoute
import org.moxultimate.topwithmox.pages.ArchitectureRoute as _org_moxultimate_topwithmox_pages_ArchitectureRoute
import org.moxultimate.topwithmox.pages.DashboardRoute as _org_moxultimate_topwithmox_pages_DashboardRoute
import org.moxultimate.topwithmox.pages.NotFoundRoute as _org_moxultimate_topwithmox_pages_NotFoundRoute
import org.moxultimate.topwithmox.pages.PanoramaRoute as _org_moxultimate_topwithmox_pages_PanoramaRoute
import org.moxultimate.topwithmox.pages.PreviewRoute as _org_moxultimate_topwithmox_pages_PreviewRoute
import org.moxultimate.topwithmox.pages.ProductAddRoute as _org_moxultimate_topwithmox_pages_ProductAddRoute
import org.moxultimate.topwithmox.pages.ProductCRUDRoute as _org_moxultimate_topwithmox_pages_ProductCRUDRoute
import org.moxultimate.topwithmox.pages.ProductDetailRoute as _org_moxultimate_topwithmox_pages_ProductDetailRoute
import org.moxultimate.topwithmox.pages.ProductItemAddRoute as _org_moxultimate_topwithmox_pages_ProductItemAddRoute
import org.moxultimate.topwithmox.pages.ProductItemUpdateRoute as _org_moxultimate_topwithmox_pages_ProductItemUpdateRoute
import org.moxultimate.topwithmox.pages.ProductUpdateRoute as _org_moxultimate_topwithmox_pages_ProductUpdateRoute
import org.moxultimate.topwithmox.pages.ProductsRoute as _org_moxultimate_topwithmox_pages_ProductsRoute
import org.moxultimate.topwithmox.pages.ShowsAddRoute as _org_moxultimate_topwithmox_pages_ShowsAddRoute
import org.moxultimate.topwithmox.pages.ShowsCRUDRoute as _org_moxultimate_topwithmox_pages_ShowsCRUDRoute
import org.moxultimate.topwithmox.pages.ShowsRoute as _org_moxultimate_topwithmox_pages_ShowsRoute
import org.moxultimate.topwithmox.pages.ShowsUpdateRoute as _org_moxultimate_topwithmox_pages_ShowsUpdateRoute
import org.moxultimate.topwithmox.pages.TechAddRoute as _org_moxultimate_topwithmox_pages_TechAddRoute
import org.moxultimate.topwithmox.pages.TechCRUDRoute as _org_moxultimate_topwithmox_pages_TechCRUDRoute
import org.moxultimate.topwithmox.pages.TechRoute as _org_moxultimate_topwithmox_pages_TechRoute
import org.moxultimate.topwithmox.pages.TechUpdateRoute as _org_moxultimate_topwithmox_pages_TechUpdateRoute
import org.moxultimate.topwithmox.pages.WallpaperAddRoute as _org_moxultimate_topwithmox_pages_WallpaperAddRoute
import org.moxultimate.topwithmox.pages.WallpaperCRUDRoute as _org_moxultimate_topwithmox_pages_WallpaperCRUDRoute
import org.moxultimate.topwithmox.pages.WallpaperDetailsRoute as _org_moxultimate_topwithmox_pages_WallpaperDetailsRoute
import org.moxultimate.topwithmox.pages.WallpaperRoute as _org_moxultimate_topwithmox_pages_WallpaperRoute
import org.moxultimate.topwithmox.pages.WallpaperUpdateRoute as _org_moxultimate_topwithmox_pages_WallpaperUpdateRoute

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "TopWithMox"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "org.moxultimate.topwithmox.components.layouts.MarkdownLayout",
            parentLayoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _org_moxultimate_topwithmox_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "org.moxultimate.topwithmox.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _org_moxultimate_topwithmox_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initDashboardRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_DashboardRoute()
        }
        ctx.router.register(
            "/404",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initNotFoundRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_NotFoundRoute()
        }
        ctx.router.register(
            "/about",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initAboutRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_AboutRoute()
        }
        ctx.router.register(
            "/apps",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initAppsRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_AppsRoute()
        }
        ctx.router.register(
            "/apps-crud",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initAppsCRUDRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_AppsCRUDRoute()
        }
        ctx.router.register(
            "/appsadd",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initAppsAddRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_AppsAddRoute()
        }
        ctx.router.register(
            "/appsupdate",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initAppsUpdateRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_AppsUpdateRoute()
        }
        ctx.router.register(
            "/architecture",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initArchitectureRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ArchitectureRoute()
        }
        ctx.router.register(
            "/panorama",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initPanoramaRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_PanoramaRoute()
        }
        ctx.router.register(
            "/preview",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initPreviewRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_PreviewRoute()
        }
        ctx.router.register(
            "/productadd",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initProductAddRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ProductAddRoute()
        }
        ctx.router.register(
            "/productdetail",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initProductDetailRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ProductDetailRoute()
        }
        ctx.router.register(
            "/productitemadd",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initProductItemAddRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ProductItemAddRoute()
        }
        ctx.router.register(
            "/productitemupdate",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initProductItemUpdateRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ProductItemUpdateRoute()
        }
        ctx.router.register(
            "/products",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initProductsRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ProductsRoute()
        }
        ctx.router.register(
            "/products-crud",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initProductCRUDRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ProductCRUDRoute()
        }
        ctx.router.register(
            "/productupdate",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initProductUpdateRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ProductUpdateRoute()
        }
        ctx.router.register(
            "/shows",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initShowsRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ShowsRoute()
        }
        ctx.router.register(
            "/shows-crud",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initShowsCRUDRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ShowsCRUDRoute()
        }
        ctx.router.register(
            "/showsadd",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initShowsAddRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ShowsAddRoute()
        }
        ctx.router.register(
            "/showsupdate",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initShowsUpdateRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_ShowsUpdateRoute()
        }
        ctx.router.register(
            "/tech",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initTechRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_TechRoute()
        }
        ctx.router.register(
            "/tech-crud",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initTechCRUDRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_TechCRUDRoute()
        }
        ctx.router.register(
            "/techadd",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initTechAddRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_TechAddRoute()
        }
        ctx.router.register(
            "/techupdate",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initTechUpdateRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_TechUpdateRoute()
        }
        ctx.router.register(
            "/wallpaper",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initWallpaperRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_WallpaperRoute()
        }
        ctx.router.register(
            "/wallpaper-crud",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initWallpaperCRUDRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_WallpaperCRUDRoute()
        }
        ctx.router.register(
            "/wallpaperadd",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initWallpaperAddRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_WallpaperAddRoute()
        }
        ctx.router.register(
            "/wallpaperdetails",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initWallpaperDetailsRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_WallpaperDetailsRoute()
        }
        ctx.router.register(
            "/wallpaperupdate",
            layoutId = "org.moxultimate.topwithmox.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.moxultimate.topwithmox.pages.initWallpaperUpdateRoute(ctx)
            },
        ) { pageCtx -> 
            _org_moxultimate_topwithmox_pages_WallpaperUpdateRoute()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("dialog-box", org.moxultimate.topwithmox.libraries.DialogBoxStyle)
        ctx.theme.registerStyle("wallpaper-carousel", org.moxultimate.topwithmox.dashboard.WallpaperCarouselStyle)
        ctx.theme.registerStyle("pulsing-image", org.moxultimate.topwithmox.components.loading.PulsingImageStyle)
        ctx.theme.registerStyle("fading-text", org.moxultimate.topwithmox.components.loading.FadingTextStyle)
        ctx.theme.registerStyle("card-hover", org.moxultimate.topwithmox.components.buttons.CardHoverStyle)
        ctx.theme.registerStyle("pressable-button", org.moxultimate.topwithmox.components.buttons.PressableButtonStyle)
        ctx.theme.registerStyle("chip-row-scroll", org.moxultimate.topwithmox.components.chip.ChipRowScrollStyle)
        ctx.theme.registerStyle("page-content", org.moxultimate.topwithmox.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("markdown", org.moxultimate.topwithmox.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("pressable-icon", org.moxultimate.topwithmox.components.image.PressableIconStyle)
        ctx.theme.registerStyle("pressable-wallpaper", org.moxultimate.topwithmox.components.image.PressableWallpaperStyle)
        ctx.theme.registerStyle("error-code", org.moxultimate.topwithmox.components.error.ErrorCodeStyle)
        ctx.theme.registerStyle("gradient-line", org.moxultimate.topwithmox.components.error.GradientLineStyle)
        ctx.theme.registerStyle("footer", org.moxultimate.topwithmox.components.footer.FooterStyle)
        ctx.theme.registerStyle("headline-text", org.moxultimate.topwithmox.theme.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", org.moxultimate.topwithmox.theme.SubheadlineTextStyle)
        ctx.theme.registerVariant("-circle", org.moxultimate.topwithmox.theme.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", org.moxultimate.topwithmox.theme.UncoloredButtonVariant
        )
        ctx.theme.registerVariant("-colored", org.moxultimate.topwithmox.theme.ColoredButtonVariant
        )
        ctx.theme.registerKeyframes("pulse", org.moxultimate.topwithmox.components.loading.PulseKeyframes)
        ctx.theme.registerKeyframes("text-fade", org.moxultimate.topwithmox.components.loading.TextFadeKeyframes)
        ctx.theme.registerKeyframes("spin", org.moxultimate.topwithmox.components.loading.SpinKeyframes)
        ctx.theme.registerKeyframes("side-menu-slide-in", org.moxultimate.topwithmox.components.navbar.SideMenuSlideInAnim)
        org.moxultimate.topwithmox.initPreconnect(ctx)
        org.moxultimate.topwithmox.initHeroPreload(ctx)
        org.moxultimate.topwithmox.initJsonLd(ctx)
        org.moxultimate.topwithmox.initSeoHead(ctx)
        org.moxultimate.topwithmox.initMonetag(ctx)
        org.moxultimate.topwithmox.initGoogleAnalytics(ctx)
        org.moxultimate.topwithmox.initColorMode(ctx)
        org.moxultimate.topwithmox.initStyles(ctx)
        org.moxultimate.topwithmox.theme.initTheme(ctx)
        org.moxultimate.topwithmox.theme.initSiteStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        org.moxultimate.topwithmox.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
